import axios from 'axios';

// ─── Onboardings ────────────────────────────────────────────────────────────

export function getOnboardings({
  status,
  schoolId,
  createdByAdminId,
  teacherEmail,
} = {}) {
  return async () => {
    const params = {};
    if (status) params.status = status;
    if (schoolId) params.schoolId = schoolId;
    if (createdByAdminId) params.createdByAdminId = createdByAdminId;
    if (teacherEmail) params.teacherEmail = teacherEmail;
    const res = await axios.get('/api/admin/onboardings', { params });
    return res.data;
  };
}

export function createOnboarding({
  name,
  notes,
  status,
  schoolId,
  school,
  courseSnapshot,
} = {}) {
  return async () => {
    const res = await axios.post('/api/admin/onboardings', {
      name,
      notes,
      status,
      schoolId,
      school,
      courseSnapshot,
    });
    return res.data;
  };
}

export function getOnboarding(id) {
  return async () => {
    const res = await axios.get(`/api/admin/onboardings/${id}`);
    return res.data;
  };
}

export function updateOnboarding(
  id,
  { name, notes, status, courseId, schoolId, school, courseSnapshot } = {},
) {
  return async () => {
    const res = await axios.patch(`/api/admin/onboardings/${id}`, {
      name,
      notes,
      status,
      courseId,
      schoolId,
      school,
      courseSnapshot,
    });
    return res.data;
  };
}

export function deleteOnboarding(id) {
  return async () => {
    const res = await axios.delete(`/api/admin/onboardings/${id}`);
    return res.data;
  };
}

// ─── Contacts ───────────────────────────────────────────────────────────────

export function addContact(
  onboardingId,
  {
    email,
    firstName,
    lastName,
    role,
    subjects,
    classes,
    schoolMediaLiteracyApproach,
    subjectsForAverPointIntegration,
  } = {},
) {
  return async () => {
    const res = await axios.post(
      `/api/admin/onboardings/${onboardingId}/contacts`,
      {
        email,
        firstName,
        lastName,
        role,
        subjects,
        classes,
        schoolMediaLiteracyApproach,
        subjectsForAverPointIntegration,
      },
    );
    return res.data;
  };
}

export function updateContact(
  onboardingId,
  contactId,
  {
    firstName,
    lastName,
    email,
    role,
    subjects,
    classes,
    schoolMediaLiteracyApproach,
    subjectsForAverPointIntegration,
    inviteStatus,
    invitedAt,
    signedUpAt,
  } = {},
) {
  return async () => {
    const res = await axios.patch(
      `/api/admin/onboardings/${onboardingId}/contacts/${contactId}`,
      {
        firstName,
        lastName,
        email,
        role,
        subjects,
        classes,
        schoolMediaLiteracyApproach,
        subjectsForAverPointIntegration,
        inviteStatus,
        invitedAt,
        signedUpAt,
      },
    );
    return res.data;
  };
}

export function getContactInviteTemplate(onboardingId, contactId) {
  return async () => {
    const res = await axios.get(
      `/api/admin/onboardings/${onboardingId}/contacts/${contactId}/invite-template`,
    );
    return res.data;
  };
}

export function deleteContact(onboardingId, contactId) {
  return async () => {
    const res = await axios.delete(
      `/api/admin/onboardings/${onboardingId}/contacts/${contactId}`,
    );
    return res.data;
  };
}

// ─── Emails ──────────────────────────────────────────────────────────────────

export function sendOnboardingEmail(
  onboardingId,
  { contactId, htmlBody, subject } = {},
) {
  return async () => {
    const res = await axios.post(
      `/api/admin/onboardings/${onboardingId}/emails`,
      {
        contactId,
        htmlBody,
        subject,
      },
    );
    return res.data;
  };
}

export function getOnboardingEmailLog(onboardingId) {
  return async () => {
    const res = await axios.get(
      `/api/admin/onboardings/${onboardingId}/emails`,
    );
    return res.data;
  };
}
